"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    root: {
        '& .prefix': {
            display: 'grid',
            gridTemplateColumns: '194px 39px 194px',
            fontSize: 10,
            fontWeight: 600,
            textTransform: 'uppercase',
            color: theme.grey5,
            padding: '0 44px'
        }
    }
});
//# sourceMappingURL=dateRange.style.js.map